"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLangData = exports.usePrefix = exports.useConfig = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var langData_1 = require("./langData");
tslib_1.__exportStar(require("./langData"), exports);
var defaultContextValue = {
    prefix: 'icecream',
    langData: langData_1.cnData
};
var configContext = react_1.createContext(defaultContextValue);
function useConfig() {
    return react_1.useContext(configContext);
}
exports.useConfig = useConfig;
function usePrefix(name, customizedPrefix) {
    var config = useConfig();
    if (customizedPrefix != null) {
        return customizedPrefix;
    }
    return config.prefix + '-' + name;
}
exports.usePrefix = usePrefix;
function useLangData(moduleName) {
    var langData = useConfig().langData;
    if (moduleName) {
        return langData[moduleName];
    }
    return langData;
}
exports.useLangData = useLangData;
function ConfigProvider(props) {
    var prefix = props.prefix, langData = props.langData, children = props.children;
    return (react_1.default.createElement(configContext.Provider, { value: { prefix: prefix, langData: langData } }, children));
}
exports.default = ConfigProvider;
ConfigProvider.defaultProps = tslib_1.__assign({}, defaultContextValue);
//# sourceMappingURL=index.js.map